import { createContext, useContext, useState, type ReactNode } from "react"

export interface ResumenState {
    footerHeight: number
    setFooterHeight: ((value: number) => void) | null
}

const defaultState: ResumenState = {
    footerHeight: 0,
    setFooterHeight: null
}

const ResumenStateContext = createContext<ResumenState>(defaultState)

export function useResumenState() {
    return useContext(ResumenStateContext)
}

interface ResumenProviderProps {
    children: ReactNode
}

export function ResumenProvider({ children }: ResumenProviderProps) {
    const [footerHeight, setFooterHeight] = useState<number>(0)

    return (
        <ResumenStateContext.Provider value={{ footerHeight, setFooterHeight }}>
            {children}
        </ResumenStateContext.Provider>
    )
}
